
<div fxLayout="column" fxLayoutGap="10px" [formGroup]="grp">



  <div fxLayout="row" fxLayoutGap="10px">

    <app-time-period-select [formControl]="grp.controls.period" multiplyLabel="Every"></app-time-period-select>

    <mat-form-field fxFlex>
      <mat-label>Base date</mat-label>
      <input matInput type="text" [matDatepicker]="baseDate" placeholder="" formControlName="baseDate" autocomplete="off">
      <mat-datepicker-toggle matSuffix [for]="baseDate"></mat-datepicker-toggle>
      <mat-datepicker #baseDate></mat-datepicker>
    </mat-form-field>

  </div>


  <div fxLayout="row" fxLayoutGap="10px">

    <mat-form-field fxFlex="240px">
      <mat-label>Max products user can scan</mat-label>
      <mat-select placeholder="" formControlName="isPercent">
        <mat-option [value]="true">In percents above the baseline</mat-option>
        <mat-option [value]="false">In number of products</mat-option>
      </mat-select>
      <mat-error>Required field</mat-error>
    </mat-form-field>

    @if (!grp.value.isPercent) {
      <mat-form-field fxFlex="120px">
        <mat-label>Max products</mat-label>
        <input matInput type="number" placeholder="" formControlName="maxValue" maxlength="6" autocomplete="off" min="0" step="1">
      </mat-form-field>
    }

    @if (grp.value.isPercent) {
      <mat-form-field fxFlex="120px">
        <mat-label>Max percent (%)</mat-label>
        <input matInput type="number" placeholder="" formControlName="maxPercent" maxlength="6" autocomplete="off" min="0" max="100" step="1">
      </mat-form-field>
    }

  </div>


  <!--<pre>{{ grp.value | json }}</pre>-->


</div>